export default function isDescendant(older, younger) {
  return (
    !!older.children &&
    typeof older.children !== 'function' &&
    older.children.some(
      child => child === younger || isDescendant(child, younger),
    )
  );
}



// WEBPACK FOOTER //
// ./src/components/@browsbox-ui/bb-react-sortable-tree-theme/utils/isDescendant.js